/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import AdminExam from './pages/AdminExam';
import AdminLessons from './pages/AdminLessons';
import AdminLevels from './pages/AdminLevels';
import AdminPracticeLab from './pages/AdminPracticeLab';
import AdminProjectEvaluations from './pages/AdminProjectEvaluations';
import AdminTracks from './pages/AdminTracks';
import Certificates from './pages/Certificates';
import ExamPage from './pages/ExamPage';
import Home from './pages/Home';
import MyProgress from './pages/MyProgress';
import Onboarding from './pages/Onboarding';
import ProjectDetail from './pages/ProjectDetail';
import Subscription from './pages/Subscription';
import TrackDetail from './pages/TrackDetail';
import Tracks from './pages/Tracks';
import VocationalTest from './pages/VocationalTest';
import MarketMap from './pages/MarketMap';
import InterviewSimulator from './pages/InterviewSimulator';
import AdminLiveLessons from './pages/AdminLiveLessons';
import LiveLessons from './pages/LiveLessons';
import AdminMarketplace from './pages/AdminMarketplace';
import Marketplace from './pages/Marketplace';
import MyPortfolio from './pages/MyPortfolio';
import PublicPortfolio from './pages/PublicPortfolio';
import VagasRemotas from './pages/VagasRemotas';
import AdminVagasRemotas from './pages/AdminVagasRemotas';
import AdminPartnerApplications from './pages/AdminPartnerApplications';
import AplicacaoParceiros from './pages/AplicacaoParceiros';
import DiscTest from './pages/DiscTest';
import ProfileSettings from './pages/ProfileSettings';
import Opportunities from './pages/Opportunities';
import OpportunityDetail from './pages/OpportunityDetail';
import MyApplications from './pages/MyApplications';
import EventCalendar from './pages/EventCalendar';
import Recordings from './pages/Recordings';
import SaboteurTest from './pages/SaboteurTest';
import AdminUsers from './pages/AdminUsers';
import Workshops from './pages/Workshops';

import __Layout from './Layout.jsx';


export const PAGES = {
    "AdminExam": AdminExam,
    "AdminLessons": AdminLessons,
    "AdminLevels": AdminLevels,
    "AdminPracticeLab": AdminPracticeLab,
    "AdminProjectEvaluations": AdminProjectEvaluations,
    "AdminTracks": AdminTracks,
    "Certificates": Certificates,
    "ExamPage": ExamPage,
    "Home": Home,
    "MyProgress": MyProgress,
    "Onboarding": Onboarding,
    "ProjectDetail": ProjectDetail,
    "Subscription": Subscription,
    "TrackDetail": TrackDetail,
    "Tracks": Tracks,
    "VocationalTest": VocationalTest,
    "MarketMap": MarketMap,
    "InterviewSimulator": InterviewSimulator,
    "AdminLiveLessons": AdminLiveLessons,
    "LiveLessons": LiveLessons,
    "AdminMarketplace": AdminMarketplace,
    "Marketplace": Marketplace,
    "MyPortfolio": MyPortfolio,
    "PublicPortfolio": PublicPortfolio,
    "VagasRemotas": VagasRemotas,
    "AdminVagasRemotas": AdminVagasRemotas,
    "AdminPartnerApplications": AdminPartnerApplications,
    "AplicacaoParceiros": AplicacaoParceiros,
    "DiscTest": DiscTest,
    "ProfileSettings": ProfileSettings,
    "Opportunities": Opportunities,
    "OpportunityDetail": OpportunityDetail,
    "MyApplications": MyApplications,
    "EventCalendar": EventCalendar,
    "Recordings": Recordings,
    "SaboteurTest": SaboteurTest,
    "AdminUsers": AdminUsers,
    "Workshops": Workshops,

}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};